module.exports = window.R;